import React from 'react'
import { PriceContext } from '..'
import { useS4LContext } from '@s4l/react-context'
import { Typography } from '@s4l/ds'
import TotalNights from '../TotalNights'

const TotalPriceComponent = () => {
  const { i18n } = useS4LContext()
  const { price, hideDiscount } = React.useContext(PriceContext)

  const isFeatured = price?.isFeaturedPrice('total')

  const discountBig = {
    variant: 'body',
    size: 'l',
  } as const

  const priceBig = {
    variant: 'title',
    size: 'xs',
  } as const

  const small = {
    variant: 'caption',
    size: 'm',
  } as const

  const discountProps = isFeatured ? discountBig : small
  const priceProps = isFeatured ? priceBig : small

  return (
    <>
      <Typography
        {...discountProps}
        className="mr-4"
        color="var(--color-neutral-800)"
        hidden={hideDiscount || !price?.hasDiscount()}
        strike
        data-testid="price-initial"
      >
        {price?.getFormatted(i18n.locale, 'priceWithoutDiscount')}
      </Typography>

      <Typography {...priceProps} color="var(--color-neutral-900)" bold data-testid="price-final">
        {price?.getFormatted(i18n.locale, 'total')}
        <TotalNights show={!isFeatured} />
      </Typography>
    </>
  )
}

TotalPriceComponent.displayName = 'Price.TotalPrice'
export const TotalPrice = TotalPriceComponent
